export const PLAYER_EVENTS = {
  FAIL: 'fail',
  PLAY: 'play',
  DEBUG: 'debug',
};

export const PUBLISHER_EVENTS = {
  STREAMING: 'streaming',
};

export const PUBLISHER_STATUSES = {
  INITIALIZING: 'initializing',
  STREAMING: 'streaming',
  STOPPED: 'stopped'
};
